const ImgSvg = ({ className }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className={className}><g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"><path d="M3 14v-9h18v14h-18v-5"/><path strokeWidth="1" d="M3 16l4 -3l3 2l6 -5l5 4"/></g><g fill="currentColor" fillOpacity="0"><circle cx="7.5" cy="9.5" r="1.5" fillOpacity="1"/><path d="M3 16l4 -3l3 2l6 -5l5 4V19H3Z" fillOpacity="1"/></g></svg>
  )
}

export default ImgSvg;